import angular from 'angular';
import ordersComponent from './orders.component';
import OrdersService from './orders.service';
import ordersConfig from './orders.config';

let ordersModule = angular.module('app.reports.orders',[])
  .component('reportOrders', ordersComponent)
  .service('ReportOrdersService', OrdersService)
  .config(ordersConfig);

export default ordersModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/reports/orders/orders.js
 **/